import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getCarrier } from '../modules/selectors';

const propTypes = {
  carrier: PropTypes.shape({
    carrierId: PropTypes.number,
    carrierName: PropTypes.string,
    aqeCarrierId: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  }),
};

const defaultProps = {
  carrier: undefined,
};

function withCarrierSubscription(WrappedComponent) {
  const wrapped = (props) => {
    const { carrier } = props;
    return <WrappedComponent {...props} key={carrier.carrierId} />;
  };
  wrapped.propTypes = propTypes;
  wrapped.defaultProps = defaultProps;
  return wrapped;
}

function mapStateToProps(state) {
  return {
    carrier: getCarrier(state),
  };
}
const composedHOC = compose(
  connect(mapStateToProps),
  withCarrierSubscription,
);
export default composedHOC;
